import createCache from '@emotion/cache';
import { createCuriosityAdapters } from '@procureai/curiosity-ui-mui';
import { FileStorageProviderProps, createFileStorageFalconAdapter } from '@procureai/uix';
import { SnackbarProviderProps } from 'notistack';
import { AuthProviderProps } from 'react-oidc-context';

import { appConfig } from '~/common/config';
import { fetchClient } from '~/services/http';
import { userManager } from '~/services/oidc';

const removeTrailingGraphqlPath = (url: string) => url.replace(/\/graphql\/?$/, '');

export const oidcConfig: AuthProviderProps = {
  userManager,
  onSigninCallback: (): void => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};

export const snackbarConfig: SnackbarProviderProps = {
  maxSnack: 3,
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
};

export const curiosityContext = {
  baseUrl: appConfig.curiosity.url,
  coreBaseUrl: appConfig.datagraph.url,
  dataAccessBaseUrl: removeTrailingGraphqlPath(appConfig.datagraph.url),
  adapters: createCuriosityAdapters({
    baseUrl: appConfig.curiosity.url,
    coreBaseUrl: appConfig.datagraph.url,
    dataAccessBaseUrl: removeTrailingGraphqlPath(appConfig.datagraph.url),
    fetchClient,
  }),
};

export const fileStorageContext: FileStorageProviderProps = {
  adapter: createFileStorageFalconAdapter({
    baseUrl: appConfig.falcon.url,
    fetchClient,
  }),
};

export const emotionCache = createCache({ key: 'mui', prepend: true });
